import React, { createRef, useRef, useState } from 'react';
import { SmallModal } from '@starrez/starryui';
import { Button, HStack, Stack, Text } from '@starrez/starryui9';
import { strings } from '../../.localisation';

type Responses = { val: 'Yes' | 'No' };
type Variant = 'YesNo';

export interface IQuestionInputProps {
    onResponse: (response: Responses) => void;
    onCancel: () => void;
    header: string;
    variant: Variant;
}

export const QuestionInput: React.FC<IQuestionInputProps> = ({ children, header, onResponse, onCancel, variant }) => {
    const BuildVariant = () => {
        const buttonRef = createRef<HTMLButtonElement>();

        return (
            <>
                {variant === 'YesNo' && (
                    <HStack gap="xSmall" justifyContent="end" columns="max-content">
                        <Button ref={buttonRef} onClick={() => onResponse({ val: 'Yes' })} variant="Primary">
                            {strings.Action_Yes}
                        </Button>
                        <Button onClick={() => onResponse({ val: 'No' })} variant="Secondary">
                            {strings.Action_No}
                        </Button>
                    </HStack>
                )}
            </>
        );
    };

    return (
        <SmallModal RenderFooter={() => <BuildVariant />} Header={header} OnCloseRequest={onCancel}>
            <Stack pad="medium">{children}</Stack>
        </SmallModal>
    );
};

type IInputType = { variant: Variant; header: string; message: string };

export const useQuestionInput = (): [React.FC<IInputType>, () => Promise<Responses>] => {
    const [showPopup, setShowPopup] = useState(false);
    const yes = useRef<(value: Responses | PromiseLike<Responses>) => void>();

    const ShowQuestion = () => {
        return new Promise<Responses>((resolve) => {
            yes.current = resolve;
            setShowPopup(true);
        });
    };

    const handleResponse = (response: Responses) => {
        yes.current && yes.current(response);
        setShowPopup(false);
    };

    const Input = ({ message, ...props }: IInputType) =>
        showPopup ? (
            <QuestionInput onResponse={handleResponse} onCancel={() => setShowPopup(false)} {...props}>
                <Text>{message}</Text>
            </QuestionInput>
        ) : (
            <></>
        );

    return [Input, ShowQuestion];
};
